import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import env from '~base/env-variables'

import api from '~base/api'

import Loader from '~base/components/spinner'
import Link from '~base/router/link'
import _ from 'lodash'
import Post from '~components/post'

export default function (options) {
  class PostList extends Component {
    constructor (props) {
      super(props)

      let page = parseInt(this.props.match.params.page)
      if (_.isNaN(page)) {
        page = 0
      }

      let domain = this.props.match.params.domain
      let investor = this.props.match.params.investor
      let startup = this.props.match.params.startup

      this.state = {
        loading: true,
        posts: null,
        votes: null,
        currentPage: page,
        domain: domain,
        investor: investor,
        startup: startup
      }
    }

    async componentWillMount () {
      await this.loadPost()
    }

    async componentWillReceiveProps (nextProps) {
      let investor = nextProps.match.params.investor
      let startup = nextProps.match.params.startup
      let page = parseInt(nextProps.match.params.page)
      if (_.isNaN(page)) {
        page = 0
      }

      await this.setState({
        currentPage: page,
        investor: investor,
        startup: startup
      })

      await this.loadPost()
    }

    async loadPost () {
      const LIMIT = 25

      var data = {
        limit: LIMIT,
        start: LIMIT * this.state.currentPage,
        sort: options.sort,
        domain: this.state.domain,
        investor: this.state.investor,
        startup: this.state.startup
      }

      var url = '/comparte/posts'
      const body = await api.get(url, data)

      await this.setState({
        loading: false,
        posts: body.data,
        votes: body.votes,
        total: body.total
      })
    }

    render () {
      if (this.state.loading) {
        return <Loader />
      }

      var posts = this.state.posts
      var votes = this.state.votes || []

      var nextPageNumber = this.state.currentPage + 1

      return (
        <div className='column is-12'>
          <div className='box content'>
            {posts.map((p) => <Post key={p.uuid} post={p} vote={votes.find(v => v.post.uuid === p.uuid)} />)}
            <article className='nextPage'>
              <div className='pull-right'>
                <Link className='button is-button' to={`${env.PREFIX + options.path}/page/${nextPageNumber}`}>Siguiente <i className='fa fa-angle-right' /></Link>
              </div>
            </article>
          </div>
        </div>
      )
    }
  }

  return {
    asRouterItem: () => {
      return [
        <Route exact path={env.PREFIX + options.path} render={props => {
          return <PostList {...props} />
        }} />,
        <Route path={env.PREFIX + options.path + '/page/:page'} render={props => {
          return <PostList {...props} />
        }} />
      ]
    }
  }
}



// WEBPACK FOOTER //
// ../frontend/components/post-list-page.js